import { PaymentGateway } from '../../../../../services/exports/Constants';

export default {
  title: 'Cliquez sur le bouton ci-dessous pour vérifier et confirmer vos informations de paiement.',
  payment_gateways: {
    [PaymentGateway.Stripe]: {
      description:
        'Nous travaillons avec Stripe pour gérer les paiements. Stripe est la plateforme de paiement la plus sécurisée, utilisée par les plus grandes entreprises mondiales.',
      form: {
        terms_acceptance: {
          label:
            'En continuant, vous acceptez notre <FoodAmigosTerms>Contrat de services</FoodAmigosTerms> et le <StripeTerms>Contrat de compte connecté Stripe.</StripeTerms>',
        },
      },
      labels: {
        stripe_requirements: "Stripe a encore besoin des informations ci-dessous ou n'a pas pu les vérifier :",
        errors: 'Erreurs',
        awaiting_verification: 'Votre compte Stripe est en cours de vérification',
        awaiting_verification_description:
          'Nous attendons que Stripe termine la vérification de votre entreprise. Vous pouvez consulter votre profil en attendant.',
        details_hint:
          "Stripe vérifie les noms, adresses et numéros de téléphone auprès de registres officiels. Si l'un d'eux est erroné, corrigez-le dans Mes informations → Informations personnelles, et Stripe le vérifiera à nouveau. Vous pouvez ajouter tout autre élément demandé par Stripe dans votre profil Stripe.",
        requirements_hint:
          "Certains de ces éléments sont des documents, comme votre pièce d'identité : importez-les à l'étape précédente, {{step}}, puis revenez ici.",
        requirements_hint_profile:
          "Certains de ces éléments sont des documents, comme votre pièce d'identité : importez-les dans votre profil Stripe.",
      },
      requirements: {
        of_subject: '{{subject}}: {{detail}}',
        subjects: {
          owner: 'Propriétaire',
          representative: 'Représentant',
          business: 'Entreprise',
        },
        details: {
          first_name: 'Prénom',
          last_name: 'Nom',
          email: 'E-mail',
          phone: 'Numéro de téléphone',
          dob: 'Date de naissance',
          id_number: "Numéro d'identité",
          nationality: 'Nationalité',
          address: 'Rue et numéro',
          city: 'Ville',
          postal_code: 'Code postal',
          state: 'État',
          country: 'Pays',
          id_document: "Pièce d'identité",
          proof_of_address: 'Justificatif de domicile',
          job_title: 'Intitulé du poste',
          business_name: 'Raison sociale',
          tax_id: 'Numéro fiscal',
          vat_id: 'Numéro de TVA',
          registration_number: "Numéro d'immatriculation",
          website: 'Site web',
          industry: "Secteur d'activité",
          product_description: 'Description de ce que vous vendez',
          support_phone: 'Numéro de téléphone du support client',
          owners: 'Confirmation des propriétaires',
          directors: 'Confirmation des dirigeants',
          executives: 'Confirmation des cadres dirigeants',
          registration_document: "Document d'immatriculation de l'entreprise",
          bank_account: 'Compte bancaire pour les versements',
          business_type: "Type d'entreprise",
          terms: 'Acceptation des conditions de Stripe',
          bank_account_proof: 'Justificatif de propriété du compte bancaire',
          tax_id_document: 'Document du numéro fiscal',
        },
      },
    },
    [PaymentGateway.Adyen]: {
      description:
        "Nous travaillons avec Adyen pour gérer les paiements. Adyen est l'une des plateformes de paiement les plus sécurisées, utilisée par les plus grandes entreprises mondiales.",
    },
  },
  labels: {
    verified: 'Votre compte {{paymentGateway}} est vérifié',
    verified_description:
      'La vérification est terminée pour {{paymentGateway}}. Vous pouvez toujours gérer votre profil si nécessaire.',
  },
  buttons: {
    proceed: 'Confirmer mes infos de paiement',
    copy_link: 'Copier le lien',
    back: 'Retour',
  },
  toasts: {
    something_went_wrong: 'Une erreur est survenue, veuillez contacter le support technique',
  },
};
